import { 
    BusinessVpvEventDto, 
    BusinessEventParamsDto, 
    BusinessUserPropertiesDto,
} from "./vpv_business.dto";
import { SHA256 } from "crypto-js";

export const BusinessVpvEvent = (data: any): BusinessVpvEventDto => {
    const { micrositio, page_path, page_type, page_title, homemarket, login, user_props = {} } = data;
    const event_params = new BusinessEventParamsDto();
    event_params.micrositio = micrositio;
    event_params.page_path = page_path;
    event_params.page_type = page_type;
    event_params.page_title = page_title;
    event_params.homemarket = homemarket;
    event_params.environment = data?.enviroment || data?.environment || 'production';
    event_params.login = login;
    
    const dto = new BusinessVpvEventDto();
    dto.event = "vpv";
    dto.event_params = event_params;

    if (user_props && Object.keys(user_props).length) {
        const user_properties = new BusinessUserPropertiesDto();
        user_properties.pas_dni_hashed = SHA256(user_props.pas_dni).toString();
        if (user_props.birthday) {
            user_properties.birthday = user_props.birthday;
        }
        user_properties.user_type = user_props.user_type;

        dto.user_properties = user_properties;
    }
    
    return dto;
}
